module.exports = __webpack_public_path__ + "static/Poland-c9668002a626410e5dead592a6cbfa88.svg";